import classNames from 'classnames';
import { SharedIcon } from 'components/SharedIcon/SharedIcon';
import { PropsWithChildren, useContext } from 'react';
import { Card } from 'react-bootstrap';
import { useAccordionButton } from 'react-bootstrap/AccordionButton';
import AccordionContext from 'react-bootstrap/AccordionContext';

interface Props {
  eventKey: string;
  hasIcon?: boolean;
  className?: string;
}

export const AccordionHeader = ({
  children,
  eventKey,
  hasIcon = true,
  className,
}: PropsWithChildren<Props>) => {
  const { activeEventKey } = useContext(AccordionContext);
  const handleClick = useAccordionButton(eventKey);

  return (
    <Card.Header
      className={classNames('cursor-pointer border-0', className)}
      onClick={handleClick}
      // previously p-3 was in className,
      // but we cannot overwrite a padding class with a "lower" padding class because bootstrap applies !important to all padding classes
      // instead we use style as the default, then overwrite with className
      // libs like tailwind-merge handle conflicting css classname resolution by letting the last class win
      style={{ padding: '1rem' }}
    >
      <div className="d-flex align-items-center">
        {hasIcon && activeEventKey !== eventKey ? (
          <SharedIcon iconName="arrow_right" />
        ) : null}

        {hasIcon && activeEventKey === eventKey ? (
          <SharedIcon iconName="arrow_drop_down" />
        ) : null}

        <div className="flex-grow-1">{children}</div>
      </div>
    </Card.Header>
  );
};
